<app-navbar></app-navbar>

<div id="principal">
    <router-outlet class="main"></router-outlet> 
</div>


<app-footer></app-footer>
